import type {SVGProps} from 'react';
import * as React from 'react';
export const BankIcon = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 24 24"
		{...props}
	>
		<path
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={1.8}
			d="M1.5 23.25h21m-1.5-12v9h-3v-9m-4.5 0v9h-3v-9m-4.5 0v9H3v-9m19.5-3h-21l9.689-5.762a1.5 1.5 0 0 1 1.622 0L22.5 8.25Z"
		/>
	</svg>
);
